import { ref, computed } from 'vue'
import { ITicketCartPayload } from '@/features/tickets/types'

export const useCart = () => {
  const cart = ref<ITicketCartPayload>({
    tiers: [],
    discountCode: '',
    contactEmail: '',
    contactName: '',
  })

  const updateCart = (ticketId: number, quantity: number) => {
    const existingTierIndex = cart.value.tiers.findIndex((tier) => tier.tierId === ticketId)

    if (quantity === 0) {
      // Remove tier if quantity is 0
      if (existingTierIndex !== -1) {
        cart.value.tiers.splice(existingTierIndex, 1)
      }
    } else if (existingTierIndex !== -1) {
      // Update existing tier
      cart.value.tiers[existingTierIndex].quantity = quantity
    } else {
      // Add new tier
      cart.value.tiers.push({ tierId: ticketId, quantity })
    }
  }

  const getCartItems = computed(() => {
    return cart.value.tiers
  })

  const isCartEmpty = computed(() => {
    return cart.value.tiers.length === 0
  })

  const clearCart = () => {
    cart.value = {
      tiers: [],
      discountCode: '',
      contactEmail: '',
      contactName: '',
    }
  }

  const updateDiscountCode = (code: string) => {
    cart.value.discountCode = code
  }

  const updateContactInfo = (email: string, name: string) => {
    cart.value.contactEmail = email
    cart.value.contactName = name
  }

  return {
    cart,
    updateCart,
    getCartItems,
    isCartEmpty,
    clearCart,
    updateDiscountCode,
    updateContactInfo,
  }
}
